<template>
  <div class="vx-col w-full lg:w-1/3 sm:w-full mb-base">
    <vx-card>
      <span class="title-head">ชำระเงินแบบปิดบัญชี</span><br>
      <div class="vx-row flex mt-8">
        <span class="vx-col flex-1 text-left label">ยอดชำระปิดบัญชี ณ วันที่</span>
        <span class="vx-col flex-1 text-right label-bold">{{ currentDate }}</span>
      </div><br>
      <div class="vx-row flex">
        <span class="vx-col flex-1 text-left label">ยอดชำระปิดบัญชี</span>
        <div class="vx-col flex-1 text-right"><span class="money-bold">{{ paymentAmountClose | numberFormat }} </span> <span class="label-bold">บาท</span></div>
      </div><br>
      <vs-button type="filled" class="w-full" color="primary"  @click="btnQrPayment('close', 0)">ชำระเงิน</vs-button>
    </vx-card>
  </div>
</template>

<script>

const moment = require('moment');
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapAccountingState } = createNamespacedHelpers('Accounting')

export default {
  name: "PaymentClose",
  props: {
    btnQrPayment: Function,
  },
  computed: {
    ...mapAccountingState(['status', 'paymentAmountDetailClose', 'paymentRoundDetail', 'contract', 'loan', 'qrPayment']),
    // disabledSubmit() {
    //   if( this.closingBalanceAmount <= 0 ) { return true }
    //   else { return false }
    // },
    // closingBalanceAmount(){
    //   if(!this.loan) return 0.00
    //   return this.loan.accruedFeeRemain + this.loan.accruedPenaltyRemain + this.loan.accruedInterestRemain + this.loan.principleRemain - this.loan.balanceRemain
    // },
    // paymentRoundDate(){
    //   if(this.contract.loan && this.paymentRoundDetail){
    //     return this.$options.filters.toThaiDDMMMYYYYFormat(moment(this.paymentRoundDetail.paymentRoundDate).add(this.contract.loan.coDate, 'days').format("YYYY-MM-DD"))
    //   }else{
    //     return "-"
    //   }
    // },
    paymentAmountClose(){
      if(!this.paymentAmountDetailClose) return 0.00
      return this.paymentAmountDetailClose.amount
    },
    currentDate(){
      if(this.contract.loan && this.paymentRoundDetail){
        return this.$options.filters.toThaiDDMMMYYYYFormat(moment().format("YYYY-MM-DD"))
      }else{
        return "-"
      }
    },
  },
}
</script>

<style scoped>

</style>


